import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import { PanelGroup } from "components/bootstrap/imports";
const StyledPanelGroup = styled(PanelGroup)`
  margin-bottom: 0;
`;
const Accordion = ({ activeKey = void 0, children, id, onSelect = () => {
}, ...restProps }) => {
  const cleanActiveKey = activeKey == null ? void 0 : activeKey.replace(/[^0-9a-zA-Z-]/g, "-").toLowerCase();
  const _onSelect = useCallback((eventKey) => onSelect(eventKey), [onSelect]);
  return /* @__PURE__ */ React.createElement(StyledPanelGroup, { ...restProps, activeKey: cleanActiveKey, id, onSelect: _onSelect, accordion: true }, children);
};
export default Accordion;
